<template>
	<li class="wf-text-right wf-list-none">
		<a href="#" @click.prevent="addCustomStyle" class="wf-text-blue-500 wf-text-xs wf-underline">add styles</a>
	</li>
</template>

<script>
	export default {
		props: {
			element: {
				type: Object,
				required: true
			}
		},
		computed: {
			elementSidebar() {
        return this.$store.getters['settingsModule/elementSidebar']
      },
			parent() {
        if (! this.elementSidebar) {
          return this.$parent.$parent  
        }
        return this.$parent
      },
			pageStyles: {
				get() {
					return this.$store.getters['pageModule/styles']
				},
				set(value) {
					this.$store.commit('pageModule/updateStyles', value)
				}
			}
		},
		methods: {
			addCustomStyle() {
				let exists = this.pageStyles.indexOf(`#${this.parent.id}`) > -1
				if (! exists) {
					this.pageStyles += `#${this.parent.id} {}`
				}
				this.$store.commit('updateToolbar', true)
				this.$store.commit('updateMenu', 'styles')
			}
		}
	}
</script>